module.exports = __webpack_public_path__ + "static/img/movibotcode.7f59dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/movibotcode.png
// module id = PxD8
// module chunks = 1